import ConfigService from "./ConfigService";

class CdnResourceResolverClass {

    getCdnConfiguration = () => ConfigService.cdnConfiguration();

    getResource(name, parameters) {
        const pattern = this.getPattern(name);
        if (pattern === null || !this.validate(pattern, parameters)) {
            return null;
        }

        return this.renderUrl(pattern, parameters);
    }

    renderUrl(pattern, parameters) {
        const url = this.getCdnConfiguration().baseUrl + '/' + pattern.basePath + '/';

        const path = pattern.pathPattern.replace(/%[^%]+%/g, function (placeholder) {
            const parameter = placeholder.slice(1, -1);
            if (parameters.hasOwnProperty(parameter)) {
                return parameters[parameter];
            } else {
                return '';
            }
        });

        return url + path.replace(/[\/]{2,}/g, '/');
    }

    getPattern(name) {
        if (this.getCdnConfiguration().patterns.hasOwnProperty(name)) {
            return this.getCdnConfiguration().patterns[name];
        }

        return null;
    }

    validate(pattern, parameters) {
        for (const field of pattern.required) {
            if (!parameters.hasOwnProperty(field)) {
                console.error(`${field} è richiesto ma non impostato`);
                return false;
            }
        }

        return true;
    }
}

let CdnResourceResolverService = new CdnResourceResolverClass();
export default CdnResourceResolverService;



// WEBPACK FOOTER //
// ./services/CdnResourceResolverService.js